import { httpClient } from '@/lib/http-client'

export const statsApi = {
    getDashboardStats: () => httpClient.get('/stats/dashboard'),
    getMaturityOverview: () => httpClient.get('/stats/maturity-overview'),
}

export const backendApi = {
    getSystemStatus: () => httpClient.get('/stats/backend/system-status'),
    getDatabaseConnection: () => httpClient.get('/stats/backend/connection/database'),
    getAiConnection: () => httpClient.get('/stats/backend/connection/ai'),
    getSmtpConnection: () => httpClient.get('/stats/backend/connection/smtp'),
    getSystemMetrics: () => httpClient.get('/stats/backend/system-metrics'),
    getDatabaseStatus: () => httpClient.get('/stats/backend/database-status'),
    refreshSystemStatus: () => httpClient.post('/stats/backend/refresh-status'),
    getHealthCheck: () => httpClient.get('/health'),
}
